import Vue from 'vue';
import VueMask from 'v-mask';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

window.Vue = require('vue').default;

Vue.component('v-select', vSelect);

Vue.component('my-header', require('./components/core/header.vue').default);

Vue.component('role-template', require('./components/core/roleTemplate.vue').default);

Vue.component('user-roles', require('./components/core/userRoles.vue').default);

Vue.component('employee-create', require('./components/hr/employeeCreate.vue').default);

Vue.component('employee-list', require('./components/hr/employeeList.vue').default);

Vue.component('admission-offered', require('./components/onlineadmission/AdmissionOffered.vue').default);

Vue.component('eligibility-criteria', require('./components/onlineadmission/eligibilityCriteria.vue').default);

Vue.component('merit-score', require('./components/onlineadmission/meritScore.vue').default);

Vue.component('newinterview-form', require('./components/onlineadmission/newInterviewForm.vue').default);

Vue.component('admissionterms-condition', require('./components/onlineadmission/admissionTermsCondition.vue').default);

Vue.component('allinterview-form', require('./components/onlineadmission/allInterviewForm.vue').default);

Vue.component('ineligible-candidates', require('./components/onlineadmission/inEligibileCandidates.vue').default);

Vue.component('ineligiblecandidates-print', require('./components/onlineadmission/inEligibileCandidatesPrint.vue').default);

Vue.component('paymentverification-form', require('./components/onlineadmission/paymentVerificationForm.vue').default);

Vue.component('create-emp-user', require('./components/core/createEmployeeUser.vue').default);

Vue.component('list-emp-user', require('./components/core/listEmployeeUser.vue').default);

Vue.component('interviewmarksentry-form', require('./components/onlineadmission/interviewMarksEntryForm.vue').default);

Vue.component('prospectstudents-verified', require('./components/onlineadmission/verifiedProspectStudents.vue').default);

Vue.component('document-verification', require('./components/onlineadmission/documentVerification.vue').default);

Vue.component('aggregate-setup', require('./components/onlineadmission/aggregateSetup.vue').default);

Vue.component('admission-form', require('./components/onlineadmission/admissionForm.vue').default);

Vue.component('menu-sorting', require('./components/core/menuSorting.vue').default);

Vue.component('form-sorting', require('./components/core/formSorting.vue').default);

Vue.component('prospect-students', require('./components/onlineadmission/prospectStudents.vue').default);

Vue.component('examination-hall', require('./components/onlineadmission/examinationHall.vue').default);

Vue.component('allexamination-hall', require('./components/onlineadmission/allExaminationHalls.vue').default);

Vue.component('challan-print', require('./components/onlineadmission/onlineChallanPrint.vue').default);

Vue.component('entry-test-create', require('./components/onlineadmission/entryTestCreate.vue').default);

Vue.component('entry-test-list', require('./components/onlineadmission/entryTestList.vue').default);

Vue.component('admission-print', require('./components/onlineadmission/AdmissionPrint.vue').default);

Vue.component('entry-test-print', require('./components/onlineadmission/entryTestPrint.vue').default);

Vue.component('entry-test-attendance-print', require('./components/onlineadmission/entryTestAttendanceSheetPrint.vue').default);

Vue.component('entry-test-mark-print', require('./components/onlineadmission/entryTestMarkSheetPrint.vue').default);

Vue.component('entry-test-mark-print-manual', require('./components/onlineadmission/entryTestMarkSheetPrint2.vue').default);

Vue.component('entrytest-marks-entry', require('./components/onlineadmission/entryTestMarksEntry.vue').default);

Vue.component('newmerit-list', require('./components/onlineadmission/newMeritList.vue').default);

Vue.component('allmerit-list', require('./components/onlineadmission/allMeritList.vue').default);

Vue.component('merit-list-print', require('./components/onlineadmission/meritListPrint.vue').default);

Vue.component('required-document', require('./components/onlineadmission/requiredDocument.vue').default);

Vue.component('data-verification-report', require('./components/onlineadmission/dataVerificationReport.vue').default);

Vue.component('data-verification-print', require('./components/onlineadmission/dataVerificationPrint.vue').default);

Vue.component('fyp-management', require('./components/DC/fypManagement.vue').default);

Vue.component('fyp-print', require('./components/DC/fypPrint.vue').default);

Vue.component('course-offered', require('./components/DC/courseOffered.vue').default);

Vue.component('course-prerequisite', require('./components/DC/coursePreRequisite.vue').default);

Vue.component('prospectstudent-enrollment', require('./components/onlineadmission/ProspectStudentEnrollment.vue').default);

Vue.component('student-course-enrollment', require('./components/DC/studentCourseEnrollment.vue').default);

Vue.component('batch-config', require('./components/DC/batchConfig.vue').default);


Vue.component('newteacher-course-enrollment', require('./components/DC/newTeacherCourseAlloment.vue').default);

Vue.component('fee-structure', require('./components/fee/feestructure.vue').default);

Vue.component('feestructure-record', require('./components/fee/feestructurerecord.vue').default);

Vue.component('prospect-feegeneration', require('./components/fee/prospectstudentfeegeneration.vue').default);

Vue.component('fee-deposit', require('./components/fee/feedeposit.vue').default);

Vue.component('prospect-challan-print', require('./components/fee/prospectstudentchallanprint.vue').default);

Vue.component('all-teacher-courseallotment', require('./components/DC/allTeacherCourseAllotment.vue').default);

Vue.component('marking-criteria', require('./components/exam/markingCriteria.vue').default);

Vue.component('instructor-work-load', require('./components/DC/instructorWorkLoad.vue').default);

Vue.component('instructor-work-load-print', require('./components/DC/instructorWorkLoadPrint.vue').default);

Vue.component('bulk-course-drop', require('./components/DC/bulkCourseDrop.vue').default);

Vue.component('course-drop', require('./components/DC/courseDrop.vue').default);

Vue.component('teacher-change-course-allotment', require('./components/DC/teacherChangeCourseAllotment.vue').default);

Vue.component('feedeposit-print', require('./components/Fee/feedepositprint.vue').default);

Vue.component('program-coursewise-studentcount', require('./components/DC/progCourseWiseStudentCount.vue').default);

Vue.component('program-coursewise-studentcount-print', require('./components/DC/progCourseWiseStudentCountPrint.vue').default);

Vue.component('comprehensive-exam', require('./components/DC/comprehensiveExam.vue').default);

Vue.component('student-active-inactive', require('./components/DC/studentActiveInActive.vue').default);

Vue.component('all-student-active-inactive', require('./components/DC/allStudentActiveInActive.vue').default);
Vue.component('email-admit-card', require('./components/onlineadmission/emailAdmitCard.vue').default);


Vue.component('internship-students', require('./components/DC/dcInternshipStudents.vue').default);

Vue.component('course-allotment-history', require('./components/DC/courseAllotmentHistory.vue').default);

Vue.component('transcript', require('./components/DC/transcript.vue').default);

Vue.component('transcript-print', require('./components/DC/transcriptPrint.vue').default);

Vue.component('onlineadmission-user', require('./components/onlineadmission/onlineadmissionuser.vue').default);

Vue.component('onlineadmission-dashboard', require('./components/onlineadmission/OnlineAdmissionDashboard.vue').default);

Vue.component('onlineadmission-report', require('./components/onlineadmission/onlineadmissionreport.vue').default);

Vue.component('onlineadmission-print', require('./components/onlineadmission/onlineadmissionprint.vue').default);

Vue.component('progwiseprospect-studentsummary', require('./components/onlineadmission/progwiseprospectstudentsummary.vue').default);

Vue.component('hostel-required-students', require('./components/onlineadmission/hostelRequiredStudents.vue').default);
Vue.component('hostel-required-students-print', require('./components/onlineadmission/hostelRequiredStudentsReport.vue').default);

Vue.component('progwiseprospect-studentprint', require('./components/onlineadmission/progwiseprospectstudentprint.vue').default);

Vue.component('category-wise-applicants-summary', require('./components/onlineadmission/categoryWiseApplicantsSummary.vue').default);

Vue.component('category-wise-applicants-print', require('./components/onlineadmission/categoryWiseApplicantsPrint.vue').default);

Vue.component('print-admit-card', require('./components/onlineadmission/admitCardPrint.vue').default);

Vue.component('program-wise-revenue', require('./components/onlineadmission/progWiseRevenue.vue').default);

Vue.component('program-wise-revenue-print', require('./components/onlineadmission/progWiseRevenuePrint.vue').default);

Vue.component('program-wise-average-marks', require('./components/onlineadmission/EntryTestAverageMarks.vue').default);

Vue.component('program-wise-average-marks-print', require('./components/onlineadmission/EntryTestAverageMarksPrint.vue').default);

Vue.component('feedeposit-record', require('./components/fee/FeeDepositRecord.vue').default);

Vue.component('fee-deposit-list', require('./components/fee/feeDepositList.vue').default);

Vue.component('fee-deposit-list-print', require('./components/fee/feeDepositListPrint.vue').default);

Vue.component('fee-generate-list-print', require('./components/fee/feeGenerationListPrint.vue').default);

Vue.component('fee-generate-list', require('./components/fee/feeGenerationList.vue').default);

Vue.component('exportstudentfrom-meritlist', require('./components/fee/exportstudentfrommeritlist.vue').default);

Vue.component('program-transfer', require('./components/onlineadmission/programTransfer.vue').default);

Vue.component('fee-refund-challan', require('./components/fee/adjustmentChallanPrint.vue').default);

Vue.component('programtransfer-report', require('./components/onlineadmission/programtransferreport.vue').default);

Vue.component('programtransfer-print', require('./components/onlineadmission/programtransferprint.vue').default);

Vue.component('coursequestion-form', require('./components/QEC/coursequestionform.vue').default);

Vue.component('teacherquestion-form', require('./components/QEC/teacherquestionform.vue').default);

Vue.component('create-evaluation', require('./components/QEC/createevaluation.vue').default);

Vue.component('all-evaluations', require('./components/QEC/allevaluations.vue').default);

Vue.component('course-registration-approval', require('./components/DC/courseRegistrationRequest.vue').default);

Vue.component('fee-deposit-summary-print', require('./components/fee/feeDepositSummaryPrint.vue').default);

Vue.component('fee-deposit-summary', require('./components/fee/feeDepositSummary.vue').default);

Vue.component('all-students-form', require('./components/DC/allStudentsForm.vue').default);

Vue.component('student-registration', require('./components/DC/studentRegistration.vue').default);

Vue.component('student-card-printing', require('./components/cardprinting/studentCardPrintProfile.vue').default);

Vue.component('student-card-edit', require('./components/cardprinting/studentCardPrintEdit.vue').default);

Vue.component('student-card-index', require('./components/cardprinting/studentCardPrintingIndex.vue').default);

Vue.component('printcard-back', require('./components/cardprinting/printcardback.vue').default);

Vue.component('printcard-front', require('./components/cardprinting/printcardfront.vue').default);

Vue.component('printcard-frontback', require('./components/cardprinting/printcardfrontback.vue').default);

Vue.component('studentprofile-report', require('./components/cardprinting/studentprofilereport.vue').default);

Vue.component('studentprofile-reportprint', require('./components/cardprinting/studentprofilereportprint.vue').default);

Vue.component('studentprofile-summaryprint', require('./components/cardprinting/studentprofilesummaryprint.vue').default);

Vue.component('employee-profileprint', require('./components/hr/employeeprofileprint.vue').default);

Vue.component('admission-form-gaus', require('./components/onlineadmission/admissionFormGAUS.vue').default);

Vue.component('admission-inquiry-report', require('./components/onlineadmission/AdmissionInquiryReport.vue').default);

Vue.component('admission-inquiry-report-print', require('./components/onlineadmission/AdmissionInquiryPrint.vue').default);

Vue.component('salary-template', require('./components/payroll/salaryTemplate.vue').default);

Vue.component('employee-salary', require('./components/payroll/employeesalary.vue').default);

Vue.component('employee-leaves-record-create', require('./components/hr/employeeLeavesRecord.vue').default);

Vue.component('employee-leaves-record-index', require('./components/hr/employeeLeavesRecordIndex.vue').default);

Vue.component('employee-job-description', require('./components/hr/employeejobdescription.vue').default);

Vue.component('admitted-students-report', require('./components/onlineadmission/AdmittedStudentsReport.vue').default);

Vue.component('admitted-students-print', require('./components/onlineadmission/AdmittedStudentsPrint.vue').default);

Vue.component('admitted-students-summary', require('./components/onlineadmission/AdmittedStudentsSummary.vue').default);
Vue.component('employee-bonus', require('./components/payroll/employeeBonus.vue').default);

Vue.component('employee-overtime', require('./components/payroll/employeeOvertime.vue').default);

Vue.component('employee-bonus-record', require('./components/payroll/employeeBonusRecord.vue').default);

Vue.component('employee-bonus-print', require('./components/payroll/employeeBonusPrint.vue').default);

Vue.component('employee-overtime-record', require('./components/payroll/employeeOvertimeRecord.vue').default);

Vue.component('employee-overtime-print', require('./components/payroll/employeeOvertimePrint.vue').default);

Vue.component('student-registration-print', require('./components/DC/StudentAdmissionPrint.vue').default);

Vue.component('road-map-print', require('./components/DC/RoadMapPrint.vue').default);

Vue.component('road-map-report', require('./components/DC/RoadMapReport.vue').default);

Vue.component('road-map-report-print', require('./components/DC/RoadMapReportPrint.vue').default);

Vue.component('course-detail-print', require('./components/DC/CourseDetailPrint.vue').default);

Vue.component('feed-back-admin', require('./components/DC/feedBackAdmin.vue').default);

Vue.component('grade-setup', require('./components/exam/GradeSetup.vue').default);

Vue.component('exam-admit-card', require('./components/exam/ExamAdmitCard.vue').default);

Vue.component('exam-admit-card-print', require('./components/exam/ExamAdmitCardPrint.vue').default);

Vue.use(VueMask);

const app = new Vue({
  el: '#app',
});



// WEBPACK FOOTER //
// ./src/main.js